// utils/frameProductObject.ts
import { Product } from '../interface/interface';
import { calculateOutOfStockEnum } from './outOfStockStatus';

type CartLineItem = { product_id: string | number; quantity: number };

export function frameProductObject(
  products: Array<Product>,
  cartLineItems: Array<CartLineItem> | undefined,
): Array<Product> {
  return products.map((product: any) => {
    const orderedQuantity =
      cartLineItems?.find(
        (item) => `${item?.product_id}` === `${product.product_code}`,
      )?.quantity ?? 0;

    if (product.substituteProduct) {
      const subProduct = product.substituteProduct;
      const subOrderedQuantity =
        cartLineItems?.find(
          (item) => `${item?.product_id}` === `${subProduct.product_code}`,
        )?.quantity ?? 0;

      return {
        ...product,
        substituteProduct: {
          ...subProduct,
          productMaxQty: product.productMaxQty,
          orderedQuantity: subOrderedQuantity,
          outOfStock: calculateOutOfStockEnum(subProduct, subOrderedQuantity),
        },
        orderedQuantity,
        outOfStock: calculateOutOfStockEnum(product, orderedQuantity),
      };
    }

    return {
      ...product,
      orderedQuantity,
      outOfStock: calculateOutOfStockEnum(product, orderedQuantity),
    };
  });
}
